package ai.wagemix

import ai.wagemix.analytics.WMSiteAnalytics
import ai.wagemix.di.initKoin
import ai.wagemix.web.theme.initWMWebTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.SideEffect
import com.fsryan.foundation.web.theme.FSColorModePersistence
import com.fsryan.foundation.web.theme.initFSWebTheme
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.core.init.InitKobweb
import com.varabyte.kobweb.core.init.InitKobwebContext
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.vh

/**
 * The site's one `@InitSilk`: foundation first, then the Wagemix brand on top of it (web-theme
 * playbook: library theme initializers are plain functions the site calls in sequence).
 */
@InitSilk
fun initWagemixSite(ctx: InitSilkContext) {
    initFSWebTheme(ctx)
    initWMWebTheme(ctx)
}

/**
 * Installs analytics before anything logs (FSLog is configured once, before its first use) and
 * follows the route for screen views (planning/analytics-plan.md §2).
 */
@InitKobweb
fun initWagemixAnalytics(ctx: InitKobwebContext) {
    WMSiteAnalytics.install(ctx.router)
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    initKoin()
    // One screen view per route path, the first on load.
    val route = WMSiteAnalytics.route.value
    LaunchedEffect(route) {
        route?.let { WMSiteAnalytics.screenViewed(it) }
    }
    SilkApp {
        // Persists the colour mode under the foundation key; foundation's head script applies it
        // before first paint on the next visit.
        FSColorModePersistence()
        val colorMode = ColorMode.current
        SideEffect { WMSiteAnalytics.colorModeIs(dark = colorMode.isDark) }
        Surface(SmoothColorStyle.toModifier().scrollBehavior(ScrollBehavior.Smooth)) {
            Box(Modifier.minHeight(100.vh)) {
                content()
            }
        }
    }
}
